import { SET_MANAGERS_DATA, SET_SHOPS_DATA } from './constants';

const initialState = {
  list: null,
  shops: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MANAGERS_DATA:
      return {
        ...state,
        list: action.payload
      };
    case SET_SHOPS_DATA:
      return {
        ...state,
        shops: action.payload
      };
    default:
      return state;
  }
};

export default reducer;